
export const FETCH_CURRENT_USER_REQUEST = 'FETCH_CURRENT_USER_REQUEST';
export const FETCH_CURRENT_USER_SUCCESS = 'FETCH_CURRENT_USER_SUCCESS';
export const FETCH_CURRENT_USER_FAILURE = 'FETCH_CURRENT_USER_FAILURE';

// update current user's team in store
export const UPDATE_CURRENT_USER_TEAM = 'UPDATE_CURRENT_USER_TEAM';

// save team to local forage
export const SAVE_CURRENT_TEAM = 'SAVE_CURRENT_TEAM';

export const UPDATE_CURRENT_USER_LANG = 'UPDATE_CURRENT_USER_LANG';

export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js